import { Config } from "@kaltura/mediaspace-shared-data-kms-config";
import { RegistrationSectionInfo } from "@kaltura/mediaspace-shared-types";
import { UserData } from "./RegistrationForm";

export enum RegistrationType {
    NEW = "new",
    EDIT = "edit",
    INVITE = "invite",
}

export interface SiteRegistrationProps {
    fullWidth?: boolean;
    title: string;
    registrationType: RegistrationType;
    userData: UserData;
    sections: RegistrationSectionInfo[];
    titleText: string;
    fieldsMappingToMarketo?: Record<string, string>[];
    marketoResponseTimeout?: number;
    recaptchaSiteKey?: string;
    recaptchaTheme?: "dark" | "light" | undefined;
    recapthcaMode?: "normal" | "invisible" | undefined;
    action?: string;
    completeTitle: string;
    completeDescriptionHtml: string;
    completeButtonText?: string;
    completeButtonUrl?: string;
    onCompleteScriptContent?: string;
    validateSsoDomains?: boolean;
    registerOtherUser?: boolean;
    onRegistrationCompleted?: () => void;
}
export default SiteRegistrationProps;
